import type { FC } from "react";
import { useUnistyles } from "react-native-unistyles";
import { Banner, Icon } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";

/** What a report email delivery is, shown above the schedule. */
export const ReportEmailDeliveryExplainer: FC = () => {
  const { theme } = useUnistyles();
  return (
    <Banner
      variant="info"
      title="What is a scheduled report?"
      message="We email you the same RoadSense Excel workbook you download today, on the schedule you choose."
      icon={<Icon name="infoOutline" size={16} color={theme.colors.interactive.buttons.secondary_foreground} />}
    />
  );
};
